import Collapse from "@mui/material/Collapse";
import { styled } from "@mui/system";
import React from "react";
import api from "src/store/features/api";

export const AnnouncementWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
  borderRadius: "4px",
  background: "#FEFCF8",
  border: "1px solid #FCF6EB",
  marginBottom: "27px",

  [theme.breakpoints.down(700)]: {
    flexDirection: "column-reverse",
    alignItems: "flex-end",
    height: "100px",
    gap: "0px",
  },
  [theme.breakpoints.down(389)]: {
    height: "120px",
  },
}));

export const TextCta = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  flex: "1 0 0",
});

export const AnnouncementText = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
});

export const RedAlert = styled("div")({
  display: "flex",
  padding: "8px 0px",
  alignItems: "flex-start",
  gap: "4px",
});

export const RedCircle = styled("div")({
  width: "4px",
  height: "4px",
  borderRadius: "10px",
  border: "1px solid #FC4C4C",
  background: "#FC4C4C",
});

export const CloseButton = styled("div")({
  display: "flex",
  padding: "6px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "6px",
  background: "#FCF6EB",
  cursor: "pointer",
});

const Announcement = () => {
  // call api here
  const { data: annoucement } = api.useGetAllPublicQuery();

  // Toggle visibility
  const [isVisible, setIsVisible] = React.useState(false);
  const handleToggle = () => setIsVisible(false);

  React.useEffect(() => {
    if (annoucement && annoucement.length > 0) setIsVisible(true);
  }, [annoucement]);

  return (
    <>
      {annoucement && annoucement.length > 0 && (
        <Collapse in={isVisible} sx={{ width: "100%" }}>
          {annoucement && (
            <AnnouncementWrapper>
              {/* TEXT + CTA */}
              <TextCta>
                <AnnouncementText>
                  <RedAlert>
                    <RedCircle />
                  </RedAlert>
                  {annoucement[0].title}
                </AnnouncementText>
              </TextCta>

              {/* BUTTON */}
              <CloseButton onClick={handleToggle}>
                <CloseIcon />
              </CloseButton>
            </AnnouncementWrapper>
          )}
        </Collapse>
      )}
    </>
  );
};

export default Announcement;

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
    <path
      d="M1 7.5L7 1.5"
      stroke="#E4AF4C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7.5L1 1.5"
      stroke="#E4AF4C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
